import { render, staticRenderFns } from "./BzCard.vue?vue&type=template&id=0f8a1bec&scoped=true&"
import script from "./BzCard.vue?vue&type=script&lang=js&"
export * from "./BzCard.vue?vue&type=script&lang=js&"
import style0 from "./BzCard.vue?vue&type=style&index=0&id=0f8a1bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8a1bec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
